import isUndefined from 'lodash/isUndefined'
import isEmpty from 'lodash/isEmpty'
import $api2 from '@/plugins/axiosInstance2.js'
import CONST from '@/const'

const state = {

}

const getters = {}

const mutations = {}

const actions = {
    GOOGLE_LOGIN: {
        // Admin sign-in via Google. Exchanges a Google ID token for our app JWT.
        root: true,
        handler(namespacedContext, payload) {
            return $api2({ method: 'post', url: '/admin/auth/google', data: { idToken: payload.idToken } })
            .then(result => {
                localStorage.setItem("srAccessToken", result.data.token)
                return result.data
            })
        }
    },
    SETCOOKIE: {
        //사용 안함
        root:true,
        handler(namespacedContext, payload) {
            // Parameter : key, value, days
            const date = new Date;
            date.setTime(date.getTime() + (payload.days * 24 * 60 * 60 * 1000))
            const expires = "expires=" + date.toUTCString()
            document.cookie = payload.key + " = " + payload.value + ";" +  expires + ";path=/"
        }
    },
    GETCOOKIE: {
        //사용 안함
        root:true,
        handler(namespacedContext, payload) {
        // Parameter : key, value, days
        const key = payload + "="
        const decodedCookie = decodeURIComponent(document.cookie)
        const ca = decodedCookie.split(';')
        for(let i=0; i < ca.length; i++) {
            const c = ca[i]
            while (c.charAt(0) == ' ') c = c.substring(1)
            if(c.indexOf(key) == 0) {
                return c.substring(key.length, c.length)
            }
        }
        return ""
        }
    },
}

export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
}
